/**
 * The public blog origin. Not read from a config module — nothing in this
 * admin exposes the marketing site's base URL (see `GenerateQRCode.js`,
 * which hardcodes `app.happypetnet.com` the same way) — so it lives here
 * as a constant until a shared config surfaces one.
 */
export const SITE_ORIGIN = "https://happypetnet.com";

/**
 * The public URL of the post a comment belongs to, or null when the post
 * has been removed (the API returns `post: null` in that case).
 * BG posts live at the root, EN posts under `/en/`.
 */
export const buildPostUrl = (post) => {
  if (!post?.slug) return null;
  const prefix = post.lang === "en" ? "/en" : "";
  return `${SITE_ORIGIN}${prefix}/${post.slug}/`;
};

/**
 * Which moderation actions make sense for a comment's current status.
 * Approve is hidden once already approved, Reject once already rejected —
 * a pending row gets both.
 */
export const nextActions = (status) => ({
  canApprove: status !== "approved",
  canReject: status !== "rejected",
});

/**
 * Append a freshly-fetched page to the rows already on screen.
 *
 * De-duplicated by `_id` rather than concatenated: the queue is paged with
 * `skip`, so a comment approved (or deleted) between two fetches shifts the
 * window and the row on the boundary would otherwise arrive twice and give
 * React two children with the same key.
 */
export const mergePage = (current, next) => {
  const seen = new Set(current.map((comment) => comment._id));
  return [...current, ...next.filter((comment) => !seen.has(comment._id))];
};
